import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="home" aria-labelledby="hero-title">
      <div className="hero-background" aria-hidden="true">
        <div className="hero-gradient"></div>
        <div className="hero-pattern"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge" role="status" aria-live="polite">
            <span className="badge-dot" aria-hidden="true"></span>
            Trusted by 20+ Global Clients
          </div>
          
          <h1 className="hero-title" id="hero-title">
            Transform Your <span className="gradient-text">Business Vision</span><br />
            Into Digital Reality
          </h1>
          
          <p className="hero-description">
            Full-spectrum consultancy services from web development and digital marketing 
            to brand creation, business consultation, data analytics, and stunning design solutions.
          </p>
          
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={scrollToContact} aria-label="Start your project with IdeasPoint">
              Start Your Project <FaArrowRight aria-hidden="true" />
            </button>
          </div>
          
          <div className="hero-stats" role="region" aria-label="Company statistics">
            <div className="stat">
              <h3 aria-label="20 plus">20+</h3>
              <p>Global Clients</p>
            </div>
            <div className="stat">
              <h3 aria-label="100 plus">100+</h3>
              <p>Projects Delivered</p>
            </div>
            <div className="stat">
              <h3>6</h3>
              <p>Core Services</p>
            </div>
            <div className="stat">
              <h3 aria-label="99 percent">99%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
